import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-082c24e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "MasterPageBackground" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "header" }, "本科专业对应考研方向", -1))
const _hoisted_3 = { id: "mainBody" }
const _hoisted_4 = { class: "bodyTitle" }
const _hoisted_5 = { class: "majorCode" }
const _hoisted_6 = { class: "mainContainer" }
const _hoisted_7 = { class: "tableContainer" }
const _hoisted_8 = { class: "tableHeaderIcon" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "paginationContainer" }
const _hoisted_11 = { class: "mainContainer" }
const _hoisted_12 = { class: "tableContainer" }
const _hoisted_13 = { class: "tableHeaderIcon" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "paginationContainer" }

import {ref, reactive, onMounted} from 'vue'
  import {masterGetMajorName, masterUndergraduateMaster} from "@/network/axios";
  import {useRouter, useRoute} from "vue-router";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MasterPage',
  setup(__props) {

  let router = useRouter();
  let route = useRoute();
  let collegeCode: any = ref('');
  let majorCode: any = ref('');
  collegeCode.value = route.params.collegeCode;
  majorCode.value = route.params.majorCode;

  //点击 tabs 栏切换触发
  let elTabId = ref('学术型硕士');
  const tabClick = (tab: any, event: any) => {
    if (tab.paneName == '学术型硕士') {
      currentPage.value = 1;
      elTabId.value = '学术型硕士';
      pageChange(1);
    } else if (tab.paneName == '专业学位硕士') {
      currentPage.value = 1;
      elTabId.value = '专业学位硕士';
      pageChange(1);
    }
  }


  //===================分页===================//
  //当前页数
  let currentPage = ref(1);
  //一页多少条
  let pageSize = ref(15);
  //一共有多少条
  let total = ref(0);
  //表格数据 获取表格信息
  const tableData = ref([])
  let pageChange = (val: any) => {
    masterUndergraduateMaster('/master/undergraduateMaster', {
      params: {
        collegeCode: collegeCode.value,
        majorCode: majorCode.value,
        masterType: elTabId.value,
        pageNumber: val,
      }
    }).then((res: any) => {
      if (res.data.code == 200) {
        // console.log(res.data.data)
        tableData.value = [];
        tableData.value = res.data.data.masters;
        total.value = parseInt(res.data.data.total);
      }
    })
  }
  pageChange(1)

  let majorName = ref('');
  masterGetMajorName('/master/getMajorName', {
    params: {
      majorCode: majorCode.value,
    }
  }).then((res) => {
    if (res.data.code == 200) {
      majorName.value = res.data.data
    }
  })

  //点击表格 对应本科专业 的 点击查看 按钮
  let goToUnderGradutePage = (row: any) => {
    window.open('/UnderGraduatePage/' + row.masterCode, '_blank')
  }


return (_ctx: any,_cache: any) => {
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode("» 本科专业：" + _toDisplayString(_unref(majorName)) + " ", 1),
        _createElementVNode("span", _hoisted_5, "专业代码：" + _toDisplayString(_unref(majorCode)), 1)
      ]),
      _createVNode(_component_el_tabs, {
        modelValue: _unref(elTabId),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(elTabId) ? (elTabId).value = $event : elTabId = $event)),
        onTabClick: tabClick,
        style: {"padding":"0 15px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "学术型硕士",
            name: "学术型硕士"
          }, {
            label: _withCtx(() => [
              _createTextVNode("学术型硕士  "),
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: "注意：显示专业为研究生招生的基础专业，不包含自设专业、交叉学科等特殊专业。",
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_QuestionFilled)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "专业学位硕士",
            name: "专业学位硕士"
          }, {
            label: _withCtx(() => [
              _createTextVNode("专业学位硕士  "),
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: "注意：显示专业为研究生招生的基础专业，不包含自设专业、交叉学科等特殊专业。",
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_QuestionFilled)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_table, {
            data: tableData.value,
            height: "100%",
            style: {"width":"100%"},
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                "show-overflow-tooltip": true,
                align: "center",
                prop: "className",
                label: "门类/类别"
              }),
              _createVNode(_component_el_table_column, {
                "show-overflow-tooltip": true,
                align: "center",
                prop: "firstSubjectName",
                label: "学科/类别"
              }),
              _createVNode(_component_el_table_column, {
                "show-overflow-tooltip": true,
                align: "center",
                prop: "masterCode",
                label: "专业代码"
              }),
              _createVNode(_component_el_table_column, {
                "show-overflow-tooltip": true,
                align: "center",
                "min-width": "115px",
                prop: "masterName",
                label: "专业名称"
              }),
              _createVNode(_component_el_table_column, {
                "show-overflow-tooltip": true,
                align: "center",
                prop: "isSet",
                label: "本校有授权点"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createTextVNode(" 本校有授权点 "),
                    _createVNode(_component_el_tooltip, {
                      effect: "dark",
                      content: "仅代表院校有授权点，是否有计划由招生院校自定。",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_QuestionFilled)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx((scope) => [
                  (scope.row.isSet == 1)
                    ? (_openBlock(), _createBlock(_component_el_icon, {
                        key: 0,
                        color: "#c30d23"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Select)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "show-overflow-tooltip": true,
                align: "center",
                label: "对应本科专业"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_link, {
                    size: "small",
                    style: {"color":"#c30d23"},
                    onClick: ($event: any) => (_unref(goToUnderGradutePage)(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 点击查看 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_pagination, {
            background: "",
            onCurrentChange: _unref(pageChange),
            "current-page": _unref(currentPage),
            "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_isRef(currentPage) ? (currentPage).value = $event : currentPage = $event)),
            "page-size": _unref(pageSize),
            "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => (_isRef(pageSize) ? (pageSize).value = $event : pageSize = $event)),
            layout: "total, prev, pager, next, jumper",
            total: _unref(total)
          }, null, 8, ["onCurrentChange", "current-page", "page-size", "total"])
        ])
      ], 512), [
        [_vShow, _unref(elTabId) == '学术型硕士']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_table, {
            data: tableData.value,
            height: "100%",
            style: {"width":"100%"},
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                "show-overflow-tooltip": true,
                align: "center",
                prop: "className",
                label: "门类/类别"
              }),
              _createVNode(_component_el_table_column, {
                "show-overflow-tooltip": true,
                align: "center",
                prop: "firstSubjectName",
                label: "学科/类别"
              }),
              _createVNode(_component_el_table_column, {
                "show-overflow-tooltip": true,
                align: "center",
                prop: "masterCode",
                label: "专业代码"
              }),
              _createVNode(_component_el_table_column, {
                "show-overflow-tooltip": true,
                align: "center",
                "min-width": "115px",
                prop: "masterName",
                label: "专业名称"
              }),
              _createVNode(_component_el_table_column, {
                "show-overflow-tooltip": true,
                align: "center",
                prop: "isSet",
                label: "本校有授权点"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createTextVNode(" 本校有授权点 "),
                    _createVNode(_component_el_tooltip, {
                      effect: "dark",
                      content: "仅代表院校有授权点，是否有计划由招生院校自定。",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_QuestionFilled)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                default: _withCtx((scope) => [
                  (scope.row.isSet == 1)
                    ? (_openBlock(), _createBlock(_component_el_icon, {
                        key: 0,
                        color: "#c30d23"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Select)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "show-overflow-tooltip": true,
                align: "center",
                label: "对应本科专业"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_link, {
                    size: "small",
                    style: {"color":"#c30d23"},
                    onClick: ($event: any) => (_unref(goToUnderGradutePage)(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 点击查看 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_pagination, {
            background: "",
            onCurrentChange: _unref(pageChange),
            "current-page": _unref(currentPage),
            "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_isRef(currentPage) ? (currentPage).value = $event : currentPage = $event)),
            "page-size": _unref(pageSize),
            "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => (_isRef(pageSize) ? (pageSize).value = $event : pageSize = $event)),
            layout: "total, prev, pager, next, jumper",
            total: _unref(total)
          }, null, 8, ["onCurrentChange", "current-page", "page-size", "total"])
        ])
      ], 512), [
        [_vShow, _unref(elTabId) == '专业学位硕士']
      ])
    ])
  ]))
}
}

})